module.exports = __webpack_public_path__ + "media/you_have_applied_now_what/you-have-applied-now-what-ca420d09.png";